import { actionTypes } from './actions';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default function fileCategoriesListReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.START_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actionTypes.REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
